import React, { ReactElement } from 'react'
import PlansProgressBar from 'components/Plans/ProgressBar/ProgressBar'
import { CurrencyDropdown } from 'components/Plans/CurrencyDropdown'
import { useAppSelector } from 'store/hooks'
import useQueryString from 'utils/useQueryString'
import { PlansSteps } from 'components/Plans/usePlanWizardSteps'
import { LoadingState } from 'store/fetchingLogic'
import { PersonalLink, StaticPageHeader } from 'components/NewStaticPage/StaticPageHeader'
import useBreakpointIndex from 'ui/Theme/useBreakpointIndex'
import { Flex } from '@theme-ui/components'

export default function PlansHeader({
  progressBarStepNames,
}: {
  progressBarStepNames?: string[]
}): ReactElement {
  const currentProduct = useAppSelector(s => s.products.currentProduct)
  const { qs } = useQueryString()
  const shouldHideCurrencySelector =
    (currentProduct && !!currentProduct.subscription?.status) ||
    qs.step === PlansSteps.CREATE_ACCOUNT ||
    qs.step === PlansSteps.SUCCESS
  const isProductsLoading = useAppSelector(s =>
    [LoadingState.IDLE, LoadingState.PENDING].includes(s.products.loading),
  )
  const isMobile = useBreakpointIndex() === 0

  return (
    <StaticPageHeader testId="plans-page-header">
      {isMobile ? (
        <MobileHeader
          isProductsLoading={isProductsLoading}
          shouldHideCurrencySelector={shouldHideCurrencySelector}
        />
      ) : (
        progressBarStepNames && (
          <DesktopTabletHeader
            isProductsLoading={isProductsLoading}
            progressBarStepNames={progressBarStepNames}
            shouldHideCurrencySelector={shouldHideCurrencySelector}
          />
        )
      )}
    </StaticPageHeader>
  )
}

function DesktopTabletHeader({
  progressBarStepNames,
  shouldHideCurrencySelector,
  isProductsLoading,
}: {
  isProductsLoading: boolean
  progressBarStepNames: string[]
  shouldHideCurrencySelector: boolean
}): ReactElement {
  const { qs } = useQueryString()

  return (
    <>
      {!isProductsLoading && (
        <>
          <PlansProgressBar stepNames={progressBarStepNames} />
          <Flex sx={{ flex: qs.step === PlansSteps.CREATE_ACCOUNT ? 0 : 1 }}>
            {!shouldHideCurrencySelector && <CurrencyDropdown />}
          </Flex>
        </>
      )}
      {qs.step === PlansSteps.CREATE_ACCOUNT && (
        <PersonalLink
          text="Go To Business Use"
          textColor="greenApple"
          directTo="/onboard"
          sx={{
            flex: 1,
            justifyContent: 'flex-end',
            '& span': {
              fontWeight: 'bold',
            },
          }}
        />
      )}
    </>
  )
}

function MobileHeader({
  shouldHideCurrencySelector,
  isProductsLoading,
}: {
  isProductsLoading: boolean
  shouldHideCurrencySelector: boolean
}): ReactElement {
  const { qs } = useQueryString()

  return (
    <>
      {!isProductsLoading && !shouldHideCurrencySelector && <CurrencyDropdown />}
      {qs.step === PlansSteps.CREATE_ACCOUNT && (
        <PersonalLink
          directTo="/onboard"
          text="Go To Business Use"
          textColor="greenApple"
          sx={{
            justifyContent: 'flex-end',
            '& span': {
              fontWeight: 'bold',
            },
          }}
        />
      )}
    </>
  )
}
